var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d: "M4 11l1.6-4.2A2 2 0 0 1 7.5 5.5h9a2 2 0 0 1 1.9 1.3L20 11",
          stroke: _vm.color,
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }),
      _c("path", {
        attrs: {
          d: "M3 11h18a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1",
          stroke: _vm.color,
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }),
      _c("path", {
        attrs: {
          d: "M4 17H3a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1",
          stroke: _vm.color,
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }),
      _c("circle", {
        attrs: {
          cx: "7",
          cy: "17.5",
          r: "1.8",
          stroke: _vm.color,
          "stroke-width": "1.6"
        }
      }),
      _c("circle", {
        attrs: {
          cx: "17",
          cy: "17.5",
          r: "1.8",
          stroke: _vm.color,
          "stroke-width": "1.6"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }